import { Icon } from "components/Icon/Icon";
import { IconCollection } from "components/Icon/IconCollection";
import { TableColumn } from "components/Table/tableUtils";
import { TimeAgoWithDateTimeFormatter } from "components/TimeAgo/TimeAgoWithDateTimeFormatter";
import {
    buildSimpleColumn,
    isEnabledColumn,
} from "containers/Search/components/SearchTabs/columns";
import { User } from "graphql/generated/graphql";

export const userColumns: (
    setValueThroughContextMenu?: (data: { field: string; value: any }) => void
) => TableColumn[] = (setNewValue) => [
    {
        label: "Email",
        key: "email",
        shown: true,
        sortable: true,
        dto: ({ email }: User) =>
            buildSimpleColumn(
                email,
                setNewValue ? () => setNewValue({ field: "email", value: email }) : undefined
            ),
        filterOptions: {
            preset: "nullable",
        },
    },
    {
        label: "2FA Enabled",
        key: "is_twofa_enabled",
        shown: true,
        sortable: false,
        dto: ({ is_twofa_enabled }: User) =>
            is_twofa_enabled
                ? buildSimpleColumn(
                      <Icon icon={IconCollection.check} />,
                      setNewValue
                          ? () =>
                                setNewValue({ field: "is_twofa_enabled", value: is_twofa_enabled })
                          : undefined
                  )
                : null,

        filterOptions: {
            preset: "ternary",
        },
    },
    isEnabledColumn(setNewValue),
    {
        label: "Activated",
        key: "is_activated",
        shown: true,
        sortable: true,
        dto: ({ is_activated }: User) =>
            is_activated
                ? buildSimpleColumn(
                      <Icon icon={IconCollection.check} />,
                      setNewValue
                          ? () => setNewValue({ field: "is_activated", value: is_activated })
                          : undefined
                  )
                : null,
        filterOptions: {
            preset: "ternary",
        },
    },
    {
        label: "Locked Out",
        key: "is_locked_out",
        shown: true,
        sortable: true,
        dto: ({ is_locked_out }: User) =>
            is_locked_out
                ? buildSimpleColumn(
                      <Icon icon={IconCollection.check} />,
                      setNewValue
                          ? () => setNewValue({ field: "is_locked_out", value: is_locked_out })
                          : undefined
                  )
                : null,
        filterOptions: {
            preset: "ternary",
        },
    },
    {
        label: "Last login",
        key: "last_login",
        shown: true,
        sortable: true,
        filterable: false,
        dto: ({ last_login }: User) =>
            last_login
                ? buildSimpleColumn(
                      <TimeAgoWithDateTimeFormatter datetime={last_login} />,
                      setNewValue
                          ? () => setNewValue({ field: "last_login", value: last_login })
                          : undefined
                  )
                : "never",
    },
    {
        label: "Last activity",
        key: "last_activity",
        shown: true,
        sortable: true,
        filterable: false,
        dto: ({ last_activity }: User) =>
            last_activity
                ? buildSimpleColumn(
                      <TimeAgoWithDateTimeFormatter datetime={last_activity} />,
                      setNewValue
                          ? () => setNewValue({ field: "last_activity", value: last_activity })
                          : undefined
                  )
                : "never",
    },
];
